import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { QRCode } from 'react-qrcode-logo';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import CopyClipboard from '../assets/copy-clip.png';

const WirebitMethod = ({link, navLink, loading, coin, amount_coin, addNotification,translations}) => {
  return(
    <>
      <p className='dark-text medium-dms bmargin0'>{translations?.checkout.wirebit_payment.title}</p>
      <p className='gray-text normal-dms'>{translations?.checkout.wirebit_payment.instructions}</p>

      { link && !loading &&
        <>
          <p className='dark-text medium-dms bmargin0'>{translations?.checkout.wirebit_payment.link_title}</p>
          <a className='gray-text normal-dms pointer copy-btn' href={link}>
            https://wirebit.com
          </a>
          <div style={{textAlign:'center'}}>
            <QRCode
              bgColor="#FFFFFF"
              fgColor="#0F4C81"
              ecLevel="M"
              style={{ width: 150, margin:'auto'}}
              value={link}
              logoWidth={70}
              logoOpacity={0.3}
              logoImage={require("../../../CryptoIcons/" + coin + ".svg")}
              qrStyle={"dots"}
            />
          </div>
        </>
      }
      {
        amount_coin &&
        <>
          <p className='dark-text medium-dms bmargin0'>{translations?.checkout.wirebit_payment.coin_amount}</p>
          <CopyToClipboard text={amount_coin}>
            <p id="ecomm-that" className='gray-text normal-dms pointer copy-btn' onClick={addNotification}>
              {amount_coin} {coin.toUpperCase()}
              <Image style={{height:23, marginTop:1, marginLeft:10}} src={CopyClipboard}/>
            </p>
          </CopyToClipboard>
        </>
      }
    </>
  )
}
export default WirebitMethod;
